<!--
    描述：系统登录页
    时间：2020.3.13
    created by ws
-->
<template>
	<div class="login-main">
		<!-- 头部信息 -->
		<div class="login-header">
			<div class="login-logo">
				<img class="logo-img"
					 src="@/assets/images/dxsz_logo.png"
					 alt="" />
			</div>
		</div>

		<!-- 中间banner -->
		<div class="login-banner">
			<div class="login-box">
				<el-form ref="loginForm"
						 :model="loginForm"
						 :rules="loginRules"
						 class="login-form"
						 autocomplete="on"
						 label-position="left"
						 label-width="0">
					<div class="title-container">鼎信造价数据库系统</div>

					<!-- 用户名 -->
					<el-form-item prop="username">
						<el-input ref="username"
								  v-model="loginForm.username"
								  placeholder="请输入用户名称"
								  name="username"
								  type="text"
								  tabindex="1"
								  @keyup.enter.native="handleLogin"
								  autocomplete="on"></el-input>
					</el-form-item>

					<!-- 用户密码 -->
					<el-tooltip v-model="capsTooltip"
								content="大写已开启"
								placement="right"
								manual>
						<el-form-item prop="password">
							<el-input :key="passwordType"
									  ref="password"
									  v-model="loginForm.password"
									  :type="passwordType"
									  placeholder="请输入密码"
									  name="password"
									  tabindex="2"
									  autocomplete="on"
									  @keyup.native="checkCapslock"
									  @blur="capsTooltip = false"
									  @keyup.enter.native="handleLogin" />
						</el-form-item>
					</el-tooltip>

					<el-button :loading="btnLoading"
							   type="primary"
							   class="login-btn btn-blue"
							   @click.native.prevent="handleLogin">确认登录</el-button>
				</el-form>
			</div>
		</div>

		<!-- 底部信息 -->
		<div class="login-footer">
			<p class="footer-text">
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				地址：安徽省合肥市经济开发区翡翠路港澳广场A座17-20层
				&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				客服热线：0551-65129999
			<p class="mt10">
				版权所有： 鼎信数智技术集团股份有限公司
				<a href="https://beian.miit.gov.cn/#/Integrated/index"
				   target="_blank"
				   class="ml20">
					皖ICP备18011150号-5
				</a>
			</p>
			</p>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getItem, removeItem } from '@/utils/auth'
export default {
	data() {
		return {
			loginForm: {
				username: '',
				password: '',
			},
			loginRules: {
				username: [
					{
						required: true,
						trigger: 'blur',
						message: '请输入用户名',
						// validator: validateUsername
					},
				],
				password: [
					{
						required: true,
						trigger: 'blur',
						message: '请输入密码',
						// validator: validatePassword
					},
				],
			},
			passwordType: 'password',
			capsTooltip: false, // 大写开启提示
			btnLoading: false,
			showDialog: false,
			redirect: undefined,
			otherQuery: {},
		}
	},
	methods: {
		...mapActions('menu', [
			'setMenu',
			'setBreadList',
			'setRouteList',
			'setTabsList',
		]),
		...mapActions('user', ['loginIn']),
		// 检查是否开启了大写
		checkCapslock(e) {
			const { key } = e
			this.capsTooltip =
				key && key.length === 1 && key >= 'A' && key <= 'Z'
		},
		// 是否显示密码(改变密码框 type)
		showPwd() {
			if (this.passwordType === 'password') {
				this.passwordType = ''
			} else {
				this.passwordType = 'password'
			}
			this.$nextTick(() => {
				this.$refs.password.focus()
			})
		},
		// 登录
		handleLogin() {
			this.btnLoading = true
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					// console.log(this.loginForm)
					// 登录接口
					this.loginIn({
						username: this.loginForm.username,
						password: this.loginForm.password,
					})
						.then(() => {
							this.$router.push({
								path: '/main',
							})
							this.btnLoading = false
						})
						.catch(() => {
							this.btnLoading = false
						})
				} else {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
					// this.$message.error('')
					return false
				}
			})
		},
		getOtherQuery(query) {
			return Object.keys(query).reduce((acc, cur) => {
				if (cur !== 'redirect') {
					acc[cur] = query[cur]
				}
				return acc
			}, {})
		},
	},
	created() {
		if (this.userInfo.id) {
			window.location.reload()
		}
		// 清除选择分析的项目列表
		if (getItem('projectList')) {
			removeItem('projectList')
		}
	},
	mounted() {
		// 初始聚焦
		if (this.loginForm.username === '') {
			this.$refs.username.focus()
		} else if (this.loginForm.password === '') {
			this.$refs.password.focus()
		}
	},
	computed: {
		// 路由列表
		routerList() {
			return this.$router.options.routes
		},
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
	},
}
</script>

<style lang="less">
.login-layout {
	height: 100%;
	background-color: #a2e8df;
	background: url('../../assets/images/login_bg.jpg');
	background-size: cover;

	.login-box {
		position: relative;
		top: 150px;
		width: 400px;
		left: 50%;
		transform: translateX(-50%);
		padding: 10px;

		.title {
			font-size: 24px;
		}

		.el-form-item {
			border: 1px solid hsla(0, 0%, 100%, 0.1);
			background: rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			color: #454545;
		}

		.el-form-item_error {
			color: #fb3131;
		}

		.el-input__inner {
			background: transparent;
			border: 0;
			-webkit-appearance: none;
			border-radius: 0;
			color: #fff;
			caret-color: #fff;
		}

		.show-pwd {
			cursor: pointer;
			user-select: none;
		}
	}
}

.login-main {
	height: 100%;
	background-color: #fff;

	.login-header {
		height: 10vh;
		box-shadow: 0px 0px 10px 0px rgba(57, 142, 141, 0.5);
		padding: 0 13%;
		font-size: 2.5vh;
		color: #000;
		display: flex;
		align-items: center;

		.login-logo {
			// height: 50%;
			height: 76px;
			margin-right: 30px;
		}

		img {
			height: 100%;
		}
	}

	.login-banner {
		// height: 44vh;
		height: 460px;
		 background: url("../../assets/images/banner-bg.jpg") no-repeat;
		// background: url("../../assets/images/login_banner_bg.jpg") no-repeat;
		background-size: 100% 100%;
		position: relative;

		.login-box {
			position: absolute;
			top: 10%;
			right: 19%;
			width: 22%;
			height: 80%;
			min-width: 320px;
			padding: 10px;
			background: #ffffff4d;
			box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
			border-radius: 10px;
		}

		.login-form {
			height: 100%;
			padding: 0 7.5%;
			background-color: #fff;
			font-size: 2.3vh;
			overflow: hidden;
			overflow-y: auto;
		}

		.title-container {
			height: 28%;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.login-btn {
			width: 100%;
			height: 40px;
			padding: 0;
			margin-top: 10px;
		}
	}

	.login-footer {
		font-size: 14px;
		color: #999;
		text-align: center;
		padding-top: 30px;
	}
	.ml20 {
		margin-left: 20px;
	}
}
</style>
